import { useState, useEffect } from 'react';
import { debounce } from '../domain/utils/debounce';
import { throttle } from '../domain/utils/throttle';

const defaultDOMRect = {
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  x: 0,
  y: 0,
  width: 0,
  height: 0
};

const getBoundingClientRect = ref =>
  ref && ref.current ? ref.current.getBoundingClientRect() : defaultDOMRect;

export const useBoundingClientRect = (
  ref,
  { throttleWait = 0, debounceWait = 0 } = {}
) => {
  const [boundingClientRect, setBoundingClientRect] = useState(() =>
    getBoundingClientRect(ref)
  );
  const handleEventRaw = () =>
    setBoundingClientRect(getBoundingClientRect(ref));
  let handleEvent = handleEventRaw;
  if (throttleWait) {
    handleEvent = throttle(handleEventRaw, throttleWait);
  }
  if (debounceWait) {
    handleEvent = debounce(handleEventRaw, debounceWait);
  }

  useEffect(() => {
    window.addEventListener('scroll', handleEvent);
    window.addEventListener('resize', handleEvent);
    return () => {
      window.removeEventListener('scroll', handleEvent);
      window.removeEventListener('resize', handleEvent);
    };
  }, [ref]);

  return boundingClientRect;
};
